"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Kpi = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Kpi = function Kpi(_ref) {
  var label = _ref.label,
      value = _ref.value,
      unit = _ref.unit,
      _ref$decimals = _ref.decimals,
      decimals = _ref$decimals === void 0 ? 0 : _ref$decimals;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: rootCSS
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: contentCSS
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: {
      display: 'flex',
      alignItems: 'baseline'
    }
  }, /*#__PURE__*/_react["default"].createElement(_.Text, {
    variant: "large",
    bold: true,
    extend: statusCSS
  }, (Number(value) || 0).toFixed(decimals)), /*#__PURE__*/_react["default"].createElement(_.Spacer, {
    size: 0.5
  }), /*#__PURE__*/_react["default"].createElement(_.Spacer, {
    size: 0.5
  }), /*#__PURE__*/_react["default"].createElement(_.Text, {
    variant: "body",
    diffuse: true
  }, unit)), /*#__PURE__*/_react["default"].createElement(_.Spacer, null), /*#__PURE__*/_react["default"].createElement(_.Text, {
    variant: "small",
    diffuse: true
  }, label)));
};

exports.Kpi = Kpi;
var rootCSS = {
  position: 'relative',
  // background: colors.contentBg,
  flex: 1,
  overflow: 'hidden' // width: "auto",
  // height: 30,
  // padding: `0 ${2 * grid}px`,
  // borderRadius: layout.radius,
  // borderRadius: 2,
  // boxShadow: shadows.big,

};

var contentCSS = function contentCSS(_ref2) {
  var grid = _ref2.theme.grid;
  return {
    // width: "auto",
    // height: 30,
    // padding: `0 ${2 * grid}px`,
    padding: 2 * grid
  };
};

var statusCSS = function statusCSS(_ref3) {
  var colors = _ref3.theme.colors;
  return {
    // position: "absolute",
    // bottom: 0,
    // left: 0,
    // top: 2 * grid,
    // right: 2 * grid,
    // width: "100%",
    // height: 2,
    // width: 16,
    // height: 16,
    // borderRadius: "50%",
    // background: colors[status],
    // color: colors[status],
    color: colors.primary
  };
};